var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cont_ranking" }, [
    _c("h3", { staticClass: "screen_out" }, [_vm._v("랭킹 목록")]),
    _vm._v(" "),
    _c("ul", { staticClass: "list_ranking" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }